/** Display label for each entity type, as the profile drawer shows it. */
export const ENTITY_TYPE_LABELS: Record<string, string> = {
  hcp: 'Provider',
  hcp_group: 'Group',
  clinic: 'Clinic',
  center: 'Hospital',
  system: 'Hospital System',
  site_of_care: 'Site of Care',
};
